module.exports = __webpack_public_path__ + "img/1F1E9-1F1EC.553b7ceb.svg";